<template>
    <section :class="css.container">
        <div :class="css.header">
            <div class="container" :class="css.header_body">
                <h2 :class="css.title" class="font-variable color-1 font-bold">{{ $t("GenesMutations") }}</h2>
                <UiTooltip :zIndex="68" :width="600" direction="bottom" align="start" :classExtraName="css_normalize.tip">
                    <img src="https://rdgta.cdn.cyagen.com/rddc/pictures/5b7a27da-b324-4878-8629-0106b3540e59.webp" alt="" />
                    <template #content>
                        <div :class="css_normalize.context">{{ $t("GenesMutationsDesc1") }}</div>
                        <div :class="css_normalize.indexs">
                            <div :class="css_normalize.index">{{ $t("GenesMutationsDesc2") }}</div>
                            <div :class="css_normalize.index">{{ $t("GenesMutationsDesc3") }}</div>
                            <div :class="css_normalize.index">{{ $t("GenesMutationsDesc4") }}</div>
                        </div>
                        <div :class="css_normalize.context">{{ $t("GenesMutationsDesc5") }}</div>
                    </template>
                </UiTooltip>
            </div>
        </div>
        <related-mutation mode="gene" :id="$route.params.id?.toString()" />
    </section>
</template>

<script lang="ts" setup>
//* 组件库
import { UiTooltip } from "various-ui";
//* 局部公共组件
import RelatedMutation from "@/views/details/components/related-mutation/index.vue";
//* 样式
import css from "./style/index.module.less";
import css_normalize from "@/assets/style/src/index.module.less";
</script>
